import React from 'react';

import { RentalAsset } from '@kaltura-ott/tvpil-shared/lib/rhino/data/rental/types';

import { RAIL_PAGE_SIZE } from 'consts';
import { WidgetProvider } from 'context/widgetProvider/widgetProvider';

import RailProvider from '../components/RailProvider/RailProvider';
import RailSkeleton from '../components/RailSkeleton/RailSkeleton';

import RentalsRailContainer from './components/RentalsRailContainer/RentalsRailContainer';
import { useRentalsRail } from './hooks/useRentalsRail/useRentalsRail';

interface Props {
  referenceId: string;
}

function RentalsRail({ referenceId }: Props) {
  const {
    railData,
    railType,
    railSettings,
    isLoading,
    isRailHidden,
    handleSkeletonRef,
    shouldPreventDisplay,
  } = useRentalsRail(referenceId);

  if (!railSettings || isRailHidden) {
    return null;
  }

  if (shouldPreventDisplay || isLoading) {
    return (
      <RailSkeleton
        handleRef={handleSkeletonRef}
        settings={railSettings}
        numberOfCells={RAIL_PAGE_SIZE}
        shouldShowHeader
      />
    );
  }

  return (
    <WidgetProvider<RentalAsset> type={railType} settings={railSettings!} data={railData}>
      <RailProvider referenceId={referenceId}>
        <RentalsRailContainer />
      </RailProvider>
    </WidgetProvider>
  );
}

export default RentalsRail;
